
import COMMON_SETTINGS from '../settings/settings.common-settings';
import { mmMatches } from '../utils/utils.matchmedia';

import * as mobileNav from './components.site-navigation-mobile';
import * as desktopNav from './components.site-navigation-desktop';

const 	siteNav = document.querySelector('.js-site-nav'),
		elements = {
			siteNav: siteNav,
			siteNavItem: siteNav.querySelectorAll('.js-site-nav-item'),
			siteNavItemWithChildren: siteNav.querySelectorAll('.js-site-nav-item-with-children'),
			toggleIcon: siteNav.querySelectorAll('.js-toggle-icon'),
			subNav: siteNav.querySelectorAll('.js-sub-nav'),
			siteNavSubItemWithChildren: siteNav.querySelectorAll('.js-site-nav-sub-item-with-children'),
			subSubNav: siteNav.querySelectorAll('.js-sub-sub-nav'),
			navCheckbox: document.querySelector('.js-nav-checkbox'),
			navNavIconInside: document.querySelector('.js-toggle-nav-icon-inside'),
			labelText: document.querySelectorAll('.js-link-text-wrap'),
		},

		classes = {
			closeIcon: 'close-icon',
			isActive: 'is-active',
			isHovered: 'is-hovered'
		};

function iconToggle() {
	elements.navCheckbox.addEventListener('click', e => {
		elements.navNavIconInside.classList.toggle(classes.closeIcon);
	});
}

function determineNavType() {
	return ( window.matchMedia( COMMON_SETTINGS.matchMediaBreakpoints.desktop ).matches ) ? 'DESKTOP' : 'MOBILE';
}

function watchForResize() {
	window.addEventListener('resize', activateCorrectNavigation);
}

function activateCorrectNavigation() {
	if ( determineNavType() === 'MOBILE' ) {
		desktopNav.reset();
		mobileNav.init();		
	} else {
		mobileNav.reset();
		desktopNav.init();
	}
}

export function getElements() {
	return elements;
}

export function getClasses() {
	return classes;
}

function init() {
	
	if ( !elements.siteNav ) return false;
	
	activateCorrectNavigation();
	watchForResize();
	iconToggle();
}

init();


